// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y8-1";
export var printerIcon = "_y8-0";